import CompositeArrayNodeBase from '../../../../framework/oop/composite/CompositeArrayNodeBase';

import DatasetsLayoutNode from './DatasetsLayoutNode';
import DatasetsLayoutNodeVisitor from './DatasetsLayoutNodeVisitor';

/**
 * An element of a layout elements tree that represents a series of elements
 * stacked left to right.
 */
class HorizontalStackLayoutNode
  extends CompositeArrayNodeBase<DatasetsLayoutNode>
  implements DatasetsLayoutNode
{
  public acceptVisitor(visitor: DatasetsLayoutNodeVisitor): void {
    visitor.visitHorizontalStack(this);
  }
}

export default HorizontalStackLayoutNode;
